import React from "react"
import { Link } from "react-router-dom"
import { Typography } from "antd"

import { Value } from "@components/Text"
import { getAmountWithoutCents } from "@components/Amount"

const COLUMNS_LABEL_MAP = {
  closeDate: "Project Funding Date",
  capitalInvested: "Capital Invested",
  returnOfCapital: "Return of Capital",
  investmentReturn: "Return on Investment",
}


const getTableColumns = () => {
  return [
    {
      key: "name",
      dataIndex: "name",
      title: "Investment",
      width: "16%",
      render: (name, { id }) =>
        <Typography.Text strong>
          <Link to={`/projects/${id}/about`}>
            {name}
          </Link>
        </Typography.Text>
    },
    {
      key: "capitalInvested",
      dataIndex: "capitalInvested",
      title: COLUMNS_LABEL_MAP.capitalInvested,
      width: "16%",
      render: value =>
        <Value value={getAmountWithoutCents(`${value}`)} />,
    },
    {
      key: "investmentReturn",
      dataIndex: "investmentReturn",
      title: COLUMNS_LABEL_MAP.investmentReturn,
      width: "16%",
      render: value =>
        <Value value={getAmountWithoutCents(`${value}`)} />,
    },
    {
      key: "returnOfCapital",
      dataIndex: "returnOfCapital",
      title: COLUMNS_LABEL_MAP.returnOfCapital,
      width: "16%",
      render: value =>
        <Value value={getAmountWithoutCents(`${value}`)} />,
    },
    {
      key: "returnedAmount",
      dataIndex: "returnedAmount",
      title: "Total Proceeds",
      width: "16%",
      render: value =>
        <Value value={getAmountWithoutCents(`${value}`)} />,
    },
    {
      key: "closeDate",
      dataIndex: "closeDate",
      title: COLUMNS_LABEL_MAP.closeDate,
      width: "16%",
      render: closeDate =>
        <Value value={closeDate} />,
    },
  ]
}

export default getTableColumns
